import { useQuery, UseQueryFunctionResult } from "@lookiero/messaging-react";
import {
  ViewIsTrendingForYouOfferingEnabledResult,
  viewIsTrendingForYouOfferingEnabled,
} from "../../../../projection/offering/viewIsTrendingForYouOfferingEnabled";
import { MESSAGING_CONTEXT_ID } from "../../../delivery/baseBootstrap";

interface UseViewIsTrendingForYouOfferingEnabledFunction {
  (): UseQueryFunctionResult<ViewIsTrendingForYouOfferingEnabledResult>;
}

const useViewIsTrendingForYouOfferingEnabled: UseViewIsTrendingForYouOfferingEnabledFunction = () =>
  useQuery({
    query: viewIsTrendingForYouOfferingEnabled(),
    contextId: MESSAGING_CONTEXT_ID,
    options: {
      staleTime: Infinity,
      retry: false,
      refetchOnWindowFocus: false,
    },
  });

export { useViewIsTrendingForYouOfferingEnabled };
